import BaseClass from './BaseClass'

/**
 * 複数のクラスをフローに載せる流用クラス
 */
export default class ThingsManagerClass extends BaseClass {
    constructor() {
        super();
        this.name = "ThingsManagerClass";
        this.things = {};
    }

    onCreate(){
        super.onCreate();
        for(let k in this.things) this.things[k].onCreate();
    }

    onLoad(){
        super.onLoad();
        for(let k in this.things) this.things[k].onLoad();
    }

    onStop(){
        super.onStop();
        for(let k in this.things) this.things[k].onStop();
    }

    onRemove(){
        super.onRemove();
        for(let k in this.things) this.things[k].onRemove();
        this.things = [];
    }

    onResize(size){
        super.onResize();
        for(let k in this.things) this.things[k].onResize(size);
    }

    onScroll(st){
        super.onScroll();
        for(let k in this.things) this.things[k].onScroll(st);
    }

    onChangeBreakPoint(b){
        super.onChangeBreakPoint();
        for(let k in this.things) this.things[k].onChangeBreakPoint(b);
    }

    onImageLoadEnd(){
        super.onImageLoadEnd();
        for(let k in this.things) {
            this.things[k].isImageLoadEnd = true;
            this.things[k].onImageLoadEnd();
        }
    }

    onYouTubeIframeAPIReady(b){
        super.onYouTubeIframeAPIReady();
        for(let k in this.things) this.things[k].onYouTubeIframeAPIReady();
    }

}